/**
 * LocalStorage utilities for saving/loading pivot view configurations
 * This will be replaced with backend API calls later
 */

import { SavedPivotView } from "../types";

const STORAGE_KEY = "pivot_views";

export const savePivotView = (view: SavedPivotView): void => {
  const views = loadAllPivotViews();
  const existingIndex = views.findIndex((v) => v.id === view.id);
  
  if (existingIndex >= 0) {
    views[existingIndex] = view;
  } else {
    views.push(view);
  }
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
};

export const loadAllPivotViews = (): SavedPivotView[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored);
  } catch (error) {
    console.error("Error loading pivot views:", error);
    return [];
  }
};

export const loadPivotView = (id: string): SavedPivotView | null => {
  const views = loadAllPivotViews();
  return views.find((v) => v.id === id) || null;
};

export const deletePivotView = (id: string): void => {
  const views = loadAllPivotViews();
  const filtered = views.filter((v) => v.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
};

export const updatePivotViewLastUsed = (id: string): void => {
  const views = loadAllPivotViews();
  const view = views.find((v) => v.id === id);
  if (view) {
    view.lastUsedAt = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
  }
};

/**
 * Sync API data to localStorage (for offline support)
 */
export const syncToLocalStorage = (views: SavedPivotView[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
};

/**
 * Delete from localStorage (helper for API delete)
 */
export const deletePivotViewFromLocalStorage = (id: string): void => {
  deletePivotView(id);
};

